import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

export interface ConfirmDialogData {
  title: string;
  message: string;
  actions: { label: string; primary: boolean; action: string }[];
}

@Component({
  selector: 'app-confirm-dialog',
  imports: [MatButtonModule, MatDialogModule, MatIconModule],
  template: `
    <div class="confirm-dialog">
      <div class="confirm-dialog__icon">
        <mat-icon>warning</mat-icon>
      </div>
      <h2 class="confirm-dialog__title">{{ data.title }}</h2>
      <p class="confirm-dialog__message">{{ data.message }}</p>
      <div class="confirm-dialog__actions">
        @for (action of data.actions; track action.action) {
          <button
            matButton
            [color]="action.primary ? 'primary' : ''"
            (click)="close(action.action)"
          >
            {{ action.label }}
          </button>
        }
      </div>
    </div>
  `,
  styles: [
    `
      .confirm-dialog {
        padding: 24px;
        text-align: center;
      }
      .confirm-dialog__icon {
        display: flex;
        justify-content: center;
        margin-bottom: 16px;
        color: var(--mat-sys-error);
      }
      .confirm-dialog__icon mat-icon {
        font-size: 48px;
        width: 48px;
        height: 48px;
      }
      .confirm-dialog__title {
        margin: 0 0 8px;
        font-size: 1.25rem;
        font-weight: 600;
      }
      .confirm-dialog__message {
        margin: 0 0 24px;
        color: var(--mat-sys-on-surface-variant);
      }
      .confirm-dialog__actions {
        display: flex;
        justify-content: center;
        gap: 8px;
      }
    `,
  ],
})
export class ConfirmDialogComponent {
  private readonly _dialogRef = inject(MatDialogRef<ConfirmDialogComponent>);
  protected readonly data = inject<ConfirmDialogData>(MAT_DIALOG_DATA);

  close(result?: string): void {
    this._dialogRef.close(result);
  }
}
